export default __webpack_public_path__ + "static/media/app_logo_veroval.231e8ca7.png";